module.exports = __webpack_public_path__ + "static/img/gyhlw.4858c591.png";